
/* injects from baggage-loader */

import Config from "../../../config/main";
import { queryBuilder } from '@lbs/swarm-client';

export const getSwarmSubscriptionRequestPromotedGamesCount = () => {
    const builder = queryBuilder()
        .useSource('betting')
        .selectGame('@count')
        .whereGame('promoted').is(true);

    if (!Config.matchOfTheDayMarketDropdown) {
        builder
            .whereMarket('type').in(['P1P2', 'P1XP2'])
            .whereEvent('type').in(['P1', 'X', 'P2']);
    } else
        builder.whereMarket('display_key').in(['WINNER', 'DOUBLE CHANCE', 'HANDICAP', 'TOTALS']);

    return builder.getParams();
};

export const getSwarmSubscriptionRequestPromotedGames = (count) => {
    const builder = queryBuilder()
        .useSource('betting')
        .selectSport(['id', 'alias', 'name'])
        .selectRegion(['id', 'name'])
        .selectCompetition(['id', 'name'])
        .selectGame(['id', 'start_ts', 'team1_name', 'team2_name', 'markets_count', 'type', 'is_stat_available', 'info', 'stats'])
        .selectMarket(['id', 'type', 'display_key'])
        .selectEvent(['base', 'price', 'type', 'id', 'name', 'order']);

    if (!Config.matchOfTheDayMarketDropdown) {
        builder
            .whereMarket('type').in(['P1P2', 'P1XP2'])
            .whereEvent('type').in(['P1', 'X', 'P2']);
    } else {
        builder.whereMarket('display_key').in(['WINNER', 'DOUBLE CHANCE', 'HANDICAP', 'TOTALS']);
    }

    if (count) builder.whereGame('promoted').is(true);
    else {
        builder
            .whereGame('type').is(1)
            .whereGame('@limit').is(Config.homeLiveGamesCount);
    }

    return builder.getParams();
};
